import script from "./NavDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./NavDropdown.vue?vue&type=style&index=0&id=4fdda7b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fdda7b8"]])

export default __exports__